import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl,github,demo }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} />
        <div className="proj-txtx">
          <h4>{title}</h4>
          <span>{description}</span>


        </div>
 
      </div>
      <div className='portfolio__item-cta'>
      <a href={github} className='btn btn-primary' target='_blank'>GitHub </a>
      <a href={demo} className='btn btn-primary' target='_blank' >Live demo</a>
      
      </div>
    
    </Col>
    
   
  )
}
